// extracted by mini-css-extract-plugin
export default {"checkoutPlanText":"Checkout_checkoutPlanText__kESg+","checkoutTerms":"Checkout_checkoutTerms__Rn88F","checkoutPlanTextContainer":"Checkout_checkoutPlanTextContainer__aU7zP"};